import { Hitbox } from "@ortho-next/three-base";
import { CircleGeometry, Group, Mesh, MeshBasicMaterial } from "three";
import { Default } from "../../Utils/Default.js";
import { Donut } from "./Donut.js";
export class DraggablePoint extends Group {
    get hideWhenDisabled() {
        return this._hideWhenDisabled;
    }
    set hideWhenDisabled(value) {
        if (this._hideWhenDisabled !== value) {
            this._hideWhenDisabled = value;
            const enabled = this.areAllEnabled;
            this.circle.material.visible = value ? enabled : true;
            this.donut.material.visible = value ? enabled : true;
        }
    }
    constructor(name, viewType, color, position, hideWhenDisable = true, scaleByCalibration = true, scale = 1) {
        super();
        this.isDraggablePoint = true;
        this.name = name;
        this._hideWhenDisabled = hideWhenDisable;
        this.add(this.circle = new Mesh(DraggablePoint.circleGeometry, new MeshBasicMaterial({ color: color, transparent: true, opacity: 0.3 })), this.donut = new Donut(color));
        this.circle.interceptedByRaycaster = false;
        position && this.position.copy(position);
        this.registerHitbox(new Hitbox(DraggablePoint.circleGeometry));
        this.isDraggable = true;
        if (scaleByCalibration) {
            Default.scaleByScaleFactorPoints(this);
            Default.bindHitboxScaleByScaleFactorAndZoom(viewType, this);
        }
        else {
            this.scale.multiplyScalar(scale);
            Default.bindHitboxScaleByZoom(viewType, this);
        }
        this.bindEvent("onHover", () => {
            this.add(Default.donut);
        });
        this.bindEvent("onLeave", () => {
            this.remove(Default.donut);
            this.needsRender = true;
        });
        this.bindEvent("onEnabledChange", (value) => {
            if (this._hideWhenDisabled) {
                this.circle.material.visible = value;
                this.donut.material.visible = value;
                this.needsRender = true;
            }
        });
        this.bindComponentVisibility();
    }
    bindComponentVisibility() {
        this.circle.bindProperty('visible', (m) => m.printState === 0, ['printState']);
        this.donut.bindProperty('visible', (m) => m.printState === 0, ['printState']);
    }
    dispose() {
        super.dispose();
        this.donut.dispose();
        this.circle.dispose();
        this.circle.material.dispose();
        //todo remove hitbox objects to raycast
    }
}
DraggablePoint.circleGeometry = new CircleGeometry(1, 32);
//# sourceMappingURL=DraggablePoint.js.map